import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ExternalLink, ShieldCheck } from "lucide-react";
import api from "@/lib/api";

const RecomiendaRedirect = () => {
  const { category, slug } = useParams();
  const [error, setError] = useState(false);
  const [url, setUrl] = useState("");

  useEffect(() => {
    api
      .get(`/products/by-slug/${category}/${slug}`)
      .then(({ data }) => {
        api.post("/track-click", { product_id: data.id }).catch(() => {});
        const target = data.affiliate_url || "";
        // Only allow safe http(s) redirects (block javascript:/data: schemes)
        const safe = /^https?:\/\//i.test(target);
        setUrl(safe ? target : "");
        if (safe) {
          setTimeout(() => window.location.replace(target), 900);
        } else {
          setError(true);
        }
      })
      .catch(() => setError(true));
  }, [category, slug]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 text-white aura relative overflow-hidden">
      <div className="relative z-10 text-center px-6">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 text-slate-950 animate-pulse">
          <ShieldCheck className="h-8 w-8" />
        </div>
        {!error ? (
          <>
            <h1 className="font-display text-2xl font-bold">Redirigiendo a la tienda oficial…</h1>
            <p className="mt-2 text-sm text-slate-400">Enlace verificado por ZeroToxicMarket</p>
            {url && (
              <a data-testid="manual-redirect-link" href={url} target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-1 text-emerald-400 hover:underline text-sm">
                Continuar manualmente <ExternalLink className="h-3 w-3" />
              </a>
            )}
          </>
        ) : (
          <>
            <h1 className="font-display text-2xl font-bold">Enlace no disponible</h1>
            <p className="mt-2 text-sm text-slate-400">Este producto aún no tiene un enlace de compra activo.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default RecomiendaRedirect;
